import styled from 'styled-components';
import {getOptImage} from 'epic-ue-shared';

export const SectionWrapper = styled.div<{bgImg: string}>`
    background-image: url(${(p) => getOptImage({url: p.bgImg}) || ''});
    background-repeat: no-repeat;
    background-position: top center;
    background-size: contain;
    section {
        background: transparent;
        border: 0;
        padding: 40px 0 0;
        ${(p) => p.theme.breakpoints.up('lg')} {
            padding: 50px 0;
        }
        .card {
            ${(p) => p.theme.breakpoints.up('xxl')} {
                margin-top: 100px;
            }
            .button-wrapper {
                margin: 40px 0 20px;
            }
            ${(p) => p.theme.breakpoints.down('sm')} {
                .btn {
                    min-width: 180px;
                }
            }
        }
        &.type-card {
            padding-bottom: 0;
        }
    }
`;

export const NewsSection = styled.div`
    background-color: ${(p) => p.theme.palette.background.default};
    margin-bottom: 3em;

    ${(p) => p.theme.breakpoints.up('md')} {
        .imageBg {
            background-size: 550px 100%;
        }
        .highlight-content-container h3.section-heading {
            font-size: 1.5em;
        }
    }
    ${(p) => p.theme.breakpoints.down('md')} {
        .highlight-content-container {
            display: flex;
            justify-content: center;
        }

        .section-heading {
            max-width: 49vw;
        }
    }

    ${(p) => p.theme.breakpoints.down('sm')} {
        .imageBg {
            background-size: 450px 100%;
        }
    }

    ${(p) => p.theme.breakpoints.down('xs')} {
        .section-heading {
            max-width: 76vw;
        }
    }
`;

export const NewsContent = styled.div`
    position: relative;
    overflow: hidden;

    .caseStudies {
        .border-top {
            margin-top: 10px;
        }
        h2 {
            width: 100%;
        }
    }

    section.noPadding {
        padding: 20px 0 !important;
        min-height: 20vh;
    }
`;

export const SliderMargin = styled.div`
    margin-top: 3em;
`;

export const NewsButtonWrap = styled.div`
    width: 100%;
    margin: 2em 0;
    text-align: center;
`;

export const Clear = styled.div`
    clear: both;
    width: 100%;
    margin: 0 0 3em;
`;
